<template>
<div>
    <v-layout>
      <v-flex xs11 ml-5 mt-3>
        <h1 class="h1">{{showTitleText}}</h1>
        <hr>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs5 mt-2>
        <h3 class="h3">ข้อมูล ปี 25{{this.$route.query.yymm}}</h3>
      </v-flex>
      <v-flex xs ml-4 mt-2>
        <h3 class="h3">พื้นที่ {{this.$route.query.ccDesc}}</h3>
        <!-- <h3>พื้นที่ {{pid}}</h3> -->
      </v-flex>
    </v-layout>
    <!-- <v-layout>
      <v-flex>
        <v-data-table v-if="this.$route.query.topic  =='statpop' " :items="info2"  hide-actions hide-headers >
          <template slot="items" slot-scope="props" >
            <td style="width:25em;"><strong style="color:red;white-space: nowrap;">ยอดรวมทั้งหมด</strong></td>
            <td class="text-xs-right" style="width:20em;"><strong style="color:red;">{{ decimalMask(props.item.maleResult) }}</strong></td>
            <td class="text-xs-right" style="width:20em;"><strong  style="color:red;">{{ decimalMask(props.item.femaleResult) }}</strong></td>
            <td class="text-xs-right" style="width:20em;"><strong  style="color:red;">{{ decimalMask(props.item.totalResult) }}</strong></td>
            <td class="text-xs-right" style="width:20em;"><strong  style="color:red;">{{ decimalMask(props.item.houseResult) }}</strong></td>
          </template>
        </v-data-table>
        <v-data-table v-if="this.$route.query.topic == 'statdeath'" :items="info2"  hide-actions hide-headers >
          <template slot="items" slot-scope="props" >
            <td style="width:25em;"><strong style="color:red;white-space: nowrap;">ยอดรวมทั้งหมด</strong></td>
            <td class="text-xs-right" style="width:20em;"><strong style="color:red;">{{ decimalMask(props.item.maleResult) }}</strong></td>
            <td class="text-xs-right" style="width:20em;"><strong  style="color:red;">{{ decimalMask(props.item.femaleResult) }}</strong></td>
            <td class="text-xs-right" style="width:20em;"><strong  style="color:red;">{{ decimalMask(props.item.totalResult) }}</strong></td>
          </template>
        </v-data-table>
        <v-data-table  v-if="this.$route.query.topic =='stathouse'" :items="info2"  hide-actions hide-headers>
          <template slot="items" slot-scope="props" >
            <td  style="width:25em;"><strong style="color:red;white-space: nowrap;">ยอดรวมทั้งหมด</strong></td>
            <td class="text-xs-right"><strong style="color:red;">{{ decimalMask(props.item.houseResult) }}</strong></td>

          </template>
        </v-data-table>
        <v-data-table  v-if="this.$route.query.topic == 'statbirth'" :items="info2"  hide-actions hide-headers>
          <template slot="items" slot-scope="props" >
            <td  style="width:25em;"><strong style="color:red;white-space: nowrap;">ยอดรวมทั้งหมด</strong></td>
            <td class="text-xs-right" style="width:20em;"><strong style="color:red;">{{ decimalMask(props.item.boyResult) }}</strong></td>
            <td class="text-xs-right" style="width:20em;"><strong  style="color:red;">{{ decimalMask(props.item.girlResult) }}</strong></td>
            <td class="text-xs-right" style="width:20em;"><strong  style="color:red;">{{ decimalMask(props.item.allResult) }}</strong></td>

          </template>
        </v-data-table>
        <v-data-table  v-if="this.$route.query.topic == 'statmovein'" :items="info2"  hide-actions hide-headers>
          <template slot="items" slot-scope="props" >
            <td style="width:25em;"><strong style="color:red;white-space: nowrap;">ยอดรวมทั้งหมด</strong></td>
            <td class="text-xs-right" style="width:20em;"><strong style="color:red;">{{ decimalMask(props.item.maleResult) }}</strong></td>
            <td class="text-xs-right" style="width:20em;"><strong  style="color:red;">{{ decimalMask(props.item.femaleResult) }}</strong></td>
            <td class="text-xs-right" style="width:20em;"><strong  style="color:red;">{{ decimalMask(props.item.totalResult) }}</strong></td>

          </template>
        </v-data-table>
        <v-data-table  v-if="this.$route.query.topic == 'statmoveout'" :items="info2"  hide-actions hide-headers>
          <template slot="items" slot-scope="props" >
            <td style="width:25em;"><strong style="color:red;white-space: nowrap;">ยอดรวมทั้งหมด</strong></td>
            <td class="text-xs-right" style="width:20em;"><strong style="color:red;">{{ decimalMask(props.item.maleResult) }}</strong></td>
            <td class="text-xs-right" style="width:20em;"><strong  style="color:red;">{{ decimalMask(props.item.femaleResult) }}</strong></td>
            <td class="text-xs-right" style="width:20em;"><strong  style="color:red;">{{ decimalMask(props.item.totalResult) }}</strong></td>

          </template>
        </v-data-table>
      </v-flex>
    </v-layout> -->
    <v-layout>
    
      <v-flex mt-3 >
  
        <v-data-table
          v-if="this.$route.query.topic =='statpop'"
          :headers="headersPOPHOUSE"
          :items="info"
          class="elevation-5"
          v-model="selected"
          :rows-per-page-items="[{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1},5,10,25]"
          rows-per-page-text="จำนวนแถวต่อหน้า"

        >

          <template slot="items" slot-scope="props" >
            <tr style="cursor: pointer;" :class="{'shown' : (props.index > 1),colorIMG2:props.index == 0}" :active="props.selected" @click="props.selected = !props.selected,onSelected(props.index)">
            <td style="white-space: nowrap;">{{ props.item.lsrcodeDesc}}</td>
            <td class="text-xs-right">{{ decimalMask(props.item.lssumtotMale) }}</td>
            <td class="text-xs-right">{{ decimalMask(props.item.lssumtotFemale) }}</td>
            <td class="text-xs-right">{{ decimalMask(props.item.lssumtotPop) }}</td>
            <td class="text-xs-right">{{ decimalMask(props.item.lssumnotTermDate) }}</td>
            </tr>
          </template>
        </v-data-table>
        <v-data-table
          v-if="this.$route.query.topic =='statdeath'"
          :headers="headersPOP"
          :items="info"
          :rows-per-page-items="[{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1},5,10,25]"
          class="elevation-5"
          v-model="selected"
          rows-per-page-text="จำนวนแถวต่อหน้า"

        >

          <template slot="items" slot-scope="props" >
            <tr   style="cursor: pointer;" :class="{'shown' : (props.index > 1),colorIMG2:props.index == 0}" :active="props.selected" @click="props.selected = !props.selected,onSelected(props.index)">
            <td style="white-space: nowrap;">{{ props.item.lsrcodeDesc}}</td>
            <td class="text-xs-right">{{ decimalMask(props.item.lssumtotMale) }}</td>
            <td class="text-xs-right">{{ decimalMask(props.item.lssumtotFemale) }}</td>
            <td class="text-xs-right">{{ decimalMask(props.item.lssumtotTot) }}</td>
            </tr>
          </template>

        </v-data-table>
        <v-data-table
          v-if="this.$route.query.topic  =='stathouse' "
          :headers="headersHouse"
          :items="info"
          v-model="selected"
          :rows-per-page-items="[{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1},5,10,25]"
          class="elevation-5"
          rows-per-page-text="จำนวนแถวต่อหน้า"

        >
          <template slot="items" slot-scope="props" >
            <tr  style="cursor: pointer;" :class="{'shown' : (props.index > 1)}" :active="props.selected" @click="props.selected = !props.selected,onSelected()">
            <td style="font-size: 16px;">{{ props.item.lsrcodeDesc}}</td>
            <td class="text-xs-right" style="font-size: 16px;">{{ decimalMask(props.item.lssumnotTermDate) }}</td>
            </tr>
          </template>

        </v-data-table>

        <v-data-table
          v-if="this.$route.query.topic  =='statbirth'"
          :headers="headersPOP"
          :items="info"
          v-model="selected"
          :rows-per-page-items="[{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1},5,10,25]"
          class="elevation-5"
          rows-per-page-text="จำนวนแถวต่อหน้า"
        >
          <template slot="items" slot-scope="props" >
            <tr  style="cursor: pointer;" :class="{'shown' : (props.index > 1),colorIMG2:props.index == 0}" :active="props.selected" @click="props.selected = !props.selected,onSelected(props.index)">
            <td style="white-space: nowrap;">{{ props.item.lsrcodeDesc }}</td>
            <td class="text-xs-right">{{ decimalMask(props.item.lssumtotalBoy) }}</td>
            <td class="text-xs-right">{{ decimalMask(props.item.lssumtotalGirl) }}</td>
            <td class="text-xs-right">{{ decimalMask(props.item.lssumtotalAll)}}</td>
            </tr>
          </template>
        </v-data-table>

          <v-data-table
          v-if="this.$route.query.topic  =='statmovein'"
          :headers="headersPOP"
          :items="info"
          v-model="selected"
            :rows-per-page-items="[{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1},5,10,25]"
          class="elevation-5"
          rows-per-page-text="จำนวนแถวต่อหน้า"
        >
          <template slot="items" slot-scope="props" >
            <tr  style="cursor: pointer;" :class="{'shown' : (props.index > 1),colorIMG2:props.index == 0}" :active="props.selected" @click="props.selected = !props.selected,onSelected(props.index)">
            <td style="white-space: nowrap;">{{ props.item.lsrcodeDesc }}</td>
            <td class="text-xs-right">{{ decimalMask(props.item.lssumtotMale) }}</td>
            <td class="text-xs-right">{{ decimalMask(props.item.lssumtotFemale) }}</td>
            <td class="text-xs-right">{{ decimalMask(props.item.lssumtotTot) }}</td>
            </tr>
          </template>
        </v-data-table>
          <v-data-table
          v-if="this.$route.query.topic =='statmoveout' "
          :headers="headersPOP"
          :items="info"
          v-model="selected"
          :rows-per-page-items="[{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1},5,10,25]"
          class="elevation-5"
          rows-per-page-text="จำนวนแถวต่อหน้า"
        >
          <template slot="items" slot-scope="props" >
          
            <tr  style="cursor: pointer;" :class="{'shown' : (props.index > 1),colorIMG2:props.index == 0}" :active="props.selected" @click="props.selected = !props.selected,onSelected(props.index)">
            <td style="white-space: nowrap;">{{ props.item.lsrcodeDesc }}</td>
            <td class="text-xs-right">{{ decimalMask(props.item.lssumtotMale) }}</td>
            <td class="text-xs-right">{{ decimalMask(props.item.lssumtotFemale) }}</td>
            <td class="text-xs-right">{{ decimalMask(props.item.lssumtotTot) }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
        <v-layout>
        <v-flex ml-0>
          <v-card-actions>
            <v-layout class="justify-center">
              <download-excel
                :data="info"
                :fields="excelField"
                :name="excelName"
                :title="excelTitle"
                :before-generate="pushData"
                :before-finish="popData"
                class="excelbtn"
                v-if="info.length > 0&&divExcel==true"
              >
                <div style="position: absolute;margin-left:10px;">
                  <img
                    src="../assets/excel.png"
                    alt="#"
                    style="height: 25px;"
                  />
                </div>
                <div style="text-align: center;padding-left: 25px;">
                  ดาวน์โหลดข้อมูล
                </div>
              </download-excel>
              <span @mousedown.right.alt.ctrl="skipScan()">
                    <v-btn small color="#0BACF2" style="color:white;margin-left:5px" @click="Winclosed()">ปิดหน้าต่าง</v-btn>
              </span>
            </v-layout>
          </v-card-actions>
        </v-flex>
      </v-layout>
      <!-- <v-layout>
        <v-flex ml-5>
          <v-btn color="#0BACF2" style="color:white; left:45%" @click="Winclosed()">ปิดหน้าต่าง</v-btn>
        </v-flex>
      </v-layout> -->
      <v-dialog
      v-model="dialog"
      hide-overlay
      persistent
      width="500"
      style="left:10%;"
      >
      <v-card
        color="light-blue darken-3"
        dark
      
      >
        <v-card-text>
          ระบบกำลังประมวลผล
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog2"
      max-width="290"
      class="center"
    >
      <v-card>
        <v-card-title class="headline center" style="font-family: 'CSChatThaiUI'">ไม่พบข้อมูลทางสถิติ</v-card-title>

        <!-- <v-card-text>
          Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.
        </v-card-text> -->

        <v-card-actions>
          <v-spacer></v-spacer>

          
          <v-btn
            color="light-blue darken-3"
            style="color:white;"
            @click="dialog2 = false"
          
          >
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  
</template>

<script>
import { mapState, Getters, mapActions } from 'vuex'
import axios from 'axios'
import router from '../router'

export default {
  name: 'tabeltem',

  data () {
    return {
      pushdata2 :[],
      dialog:true,
      dialog2:false,
      action:'11',
      info2:[{
        totalResult:0,
        maleResult:0,
        femaleResult:0,
        boyResult:0,
        girlResult:0,
        allResult:0,
        houseResult:0,
      }],
      infoMovein:[{
        totalResult:0,
        maleResult:0,
        femaleResult:0,
      }],
      infoMoveout:[{
        totalResult:0,
        maleResult:0,
        femaleResult:0,
      }],
      infoHouse:[
        {
          houseResult:0,
        }
      ],
      infoBirth:[
        {
          boyResult:0,
          girlResult:0,
          allResult:0,
        }
      ],
      femaleResult: 0,
      maleResult: 0,
      totalResult:0,
      getTTText: '',
      getMMText:'',
      getCCtext:'',
      getRRcodetext:'',
      getrouterText:null,
      Detial: 'เดือน',
      Area: 'ทั่วประเทศ',
      headersPOP: [
        {
          text: 'พื้นที่',
          align: 'left',
          sortable: false,
          value: 'name',
        },
        { text: 'ชาย (คน)', value: 'name', sortable: false, align: 'right'},
        { text: 'หญิง (คน)', value: 'nameDesc', sortable: false, align: 'right' },
        { text: 'รวม (คน)', value: 'nameDesc', sortable: false, align: 'right' }
      ],
      headersPOPHOUSE: [
        {
          text: 'พื้นที่',
          align: 'left',
          sortable: false,
          value: 'name',
        },
        { text: 'ชาย (คน)', value: 'name', sortable: false, align: 'right'},
        { text: 'หญิง (คน)', value: 'nameDesc', sortable: false, align: 'right' },
        { text: 'รวม (คน)', value: 'nameDesc', sortable: false, align: 'right' },
        { text: 'บ้าน (หลัง)', value: 'nameDesc', sortable: false, align: 'right' }
        
      ],
      headersHouse: [
        {
          text: 'พื้นที่',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        // { text: 'ย้าน1', value: 'name',sortable: false, },
        { text: 'จำนวน(หลัง)', value: 'nameDesc', sortable: false, align: 'right' }
      ],
      headersBirth: [
        {
          text: 'เกิดรวม',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'ผู้ชาย(การเกิด)', value: 'name', sortable: false },
        { text: 'ผู้หญิง(การเกิด)', value: 'nameDesc', sortable: false }
      ],
      info: [],
      test: '',
      actionid: '',
      getTitle: null,
      pid: null,
      TextTitle:null,
      clerkName: null,
      workPlace: null,
      selected:[],
      excelName: "",
      excelTitle: [],
      excelField: [],
      divExcel:true,
    }
  },
  computed: {
    ...mapState({
      titleText: store => store.StoreFilterVal.titleText,
      flagtitle: store => store.StoreFilterVal.flagtitle,
      // action: store => store.StoreFilterVal.action,
      yymm_b: store => store.StoreFilterVal.yymm_b,
      yymm_e: store => store.StoreFilterVal.yymm_e,
      statType: store => store.StoreFilterVal.statType,
      cc: store => store.StoreFilterVal.cc,
      rcode: store => store.StoreFilterVal.rcode,
      tt: store => store.StoreFilterVal.tt,
      mm: store => store.StoreFilterVal.mm,
      region: store => store.StoreFilterVal.region,
      topicID: store => store.StoreFilterVal.topicID,
      filterID: store => store.StoreFilterVal.filterID,
      infoFilter: store => store.StoreFilterVal.infoFilter
      // coins:store => store.StoreFilterVal.coins
    }),
    showTitleText(){
    let id = this.$route.query.topic
    if(id == 'statpop'){
      this.TextTitle = 'สถิติจำนวนประชากรและบ้าน'  
        return 'สถิติจำนวนประชากรและบ้าน'  
      }else if(id == 'stathouse'){
        this.TextTitle =  'บ้านจากทะเบียนบ้าน' 
        return 'บ้านจากทะเบียนบ้าน' 
      }else if(id == 'statbirth'){
        this.TextTitle =  'สถิติจำนวนการเกิด'
        return 'สถิติจำนวนการเกิด'
      }else if(id == 'statmoveout'){
        this.TextTitle =  'สถิติจำนวนการย้ายออก'
        return 'สถิติจำนวนการย้ายออก'
      }else if(id == 'statmovein'){
        this.TextTitle = 'สถิติจำนวนการย้ายเข้า'
        return  'สถิติจำนวนการย้ายเข้า'
      }else if(id == 'statdeath'){
        this.TextTitle = 'สถิติจำนวนการตาย'
        return  'สถิติจำนวนการตาย'
      }
    }, 
  },

  created () {
    this.id = this.$route.params.id
    let a = this.action
    this.getrouterText = this.$route.params.title
    let topicID = this.$route.query.topic
    let yymm_b = this.$route.query.yymm
        if(topicID == 'statpop'){
            let reAction = 193;
            // if(this.$route.query.cc != null){
            //   let a = this.$route.query.cc.toString().substring(0,1)
            //   reAction = 43
            // } 
            axios
                .get(
                '../connectSAPI/stat_forward.php?API=/api/statpophouse/v1/' +
                  topicID +
                    '/list?action=' +
                    reAction
                    +
                    '&yymmBegin=' +
                    (yymm_b +'12') +
                    '&yymmEnd=' +
                    (yymm_b +'12' )+
                    '&statType=0&statSubType=999&subType=99&region='+
                    this.$route.query.ccNo.substring(0,1)+
                    '&cc=' +
                    Number(this.$route.query.ccNo) +
                    '&rcode=' +
                    Number(this.rcode) +
                    '&tt=' +
                    Number(this.tt) +
                    '&mm=' +
                    Number(this.mm)
                )
                // &region=1&cc='+this.cc+'&rcode='+this.rcode+'&tt='+this.tt+'&mm='+this.mm)
                .then(response => {
                this.dialog = false
                this.info = response.data
              var a = response.data
              for (var i = 0, n = a.length; i < n; i++) {
                this.info2[0].femaleResult +=   a[i].lssumtotFemale;
                this.info2[0].maleResult  +=   a[i].lssumtotMale;
                this.info2[0].totalResult   +=  a[i].lssumtotPop;
                this.info2[0].houseResult  += a[i].lssumnotTermDate
              } 
              // info2[0].totalResult = this.totalResult;
              // info2[0].maleResult = this.maleResult;
              // info2[0].femaleResult = this.femaleResult;
              this.info.unshift({
                lsrcodeDesc: 'ยอดรวมทั้งหมด',
                lssumtotFemale: this.info2[0].femaleResult,
                lssumtotMale: this.info2[0].maleResult,
                lssumtotPop: this.info2[0].totalResult,
                lssumnotTermDate: this.info2[0].houseResult,
                lssumtotHouse:  this.info2[0].houseResult
              })
                })
                .catch(e => {
                this.dialog = false
                this.dialog2 = true
                this.errors.push(e)
                })
        }else if(topicID == 'stathouse'){
        let reAction = 33;
            axios
                .get(
                '../connectSAPI/stat_forward.php?API=/api/statpophouse/v1/' +
                    topicID +
                    '/list?action=' +
                    reAction
                    +
                    '&yymmBegin=' +
                    (yymm_b +'12') +
                    '&yymmEnd=' +
                    (yymm_b +'12' )+
                    '&statType=0&statSubType=999&subType=99&region='+
                    this.region+
                    '&cc=' +
                    Number(this.$route.query.ccNo) +
                    '&rcode=' +
                    Number(this.rcode) +
                    '&tt=' +
                    Number(this.tt) +
                    '&mm=' +
                    Number(this.mm)
                )
                // &region=1&cc='+this.cc+'&rcode='+this.rcode+'&tt='+this.tt+'&mm='+this.mm)
                .then(response => {
                this.dialog = false
                this.info = response.data
                var a = response.data;
                for (var i = 0, n = a.length; i < n; i++) {
                  this.info2[0].houseResult +=   a[i].lssumnotTermDate;
                } 
                })
                .catch(e => {
                this.dialog = false
                this.dialog2 = true
                this.errors.push(e)
                })
        }else if(topicID == 'statbirth'){
        let a = this.action.toString();
        let reAction = '193';
            axios
                .get(
                '../connectSAPI/stat_forward.php?API=/api/stattranall/v1/' +
                    topicID +
                    '/list?action=' +
                    reAction
                    +
                    '&yymmBegin=' +
                    (yymm_b +'12') +
                    '&yymmEnd=' +
                    (yymm_b +'12' )+
                    '&statType=0&statSubType=999&subType=99&region='+
                    this.region+
                    '&cc=' +
                    Number(this.$route.query.ccNo) +
                    '&rcode=' +
                    Number(this.rcode) +
                    '&tt=' +
                    Number(this.tt) +
                    '&mm=' +
                    Number(this.mm)
                )
                // &region=1&cc='+this.cc+'&rcode='+this.rcode+'&tt='+this.tt+'&mm='+this.mm)
                .then(response => {
                this.dialog = false
                this.info = response.data
                var a = response.data
                for (var i = 0, n = a.length; i < n; i++) {
                  this.info2[0].boyResult +=   a[i].lssumtotalBoy;
                  this.info2[0].girlResult +=   a[i].lssumtotalGirl;
                  this.info2[0].allResult +=   a[i].lssumtotalAll;
                } 
                this.info.unshift({
                  lsrcodeDesc: 'ยอดรวมทั้งหมด',
                  lssumtotalBoy: this.info2[0].boyResult,
                  lssumtotalGirl: this.info2[0].girlResult,
                  lssumtotalAll: this.info2[0].allResult
                })
                })
                .catch(e => {
                this.dialog = false
                this.dialog2 = true
                this.errors.push(e)
                })
        }else if(topicID == 'statdeath'){
        let a = this.action.toString();
        let reAction = '193';
            axios
                .get(
                  '../connectSAPI/stat_forward.php?API=/api/stattranall/v1/' +
                    topicID +
                    '/list?action=' +
                    reAction
                    +
                    '&yymmBegin=' +
                    (yymm_b +'12') +
                    '&yymmEnd=' +
                    (yymm_b +'12' )+
                    '&statType=0&statSubType=999&subType=99&region='+
                    this.region+
                    '&cc=' +
                    Number(this.$route.query.ccNo) +
                    '&rcode=' +
                    Number(this.rcode) +
                    '&tt=' +
                    Number(this.tt) +
                    '&mm=' +
                    Number(this.mm)
                )
                // &region=1&cc='+this.cc+'&rcode='+this.rcode+'&tt='+this.tt+'&mm='+this.mm)
                .then(response => {
                this.dialog = false
                this.info = response.data
                var a = response.data
                for (var i = 0, n = a.length; i < n; i++) {
                  this.info2[0].maleResult +=   a[i].lssumtotMale;
                  this.info2[0].femaleResult +=   a[i].lssumtotFemale;
                  this.info2[0].totalResult +=   a[i].lssumtotTot;
                } 
                this.info.unshift({
                  lsrcodeDesc: 'ยอดรวมทั้งหมด',
                  lssumtotMale: this.info2[0].maleResult,
                  lssumtotFemale: this.info2[0].femaleResult,
                  lssumtotTot: this.info2[0].totalResult
                })
                })
                .catch(e => {
                this.dialog = false
                this.dialog2 = true
                this.errors.push(e)
                })
        }else if(topicID == 'statmovein'){
        let a = this.action.toString();
        let reAction = '193';
            axios
                .get(
                '../connectSAPI/stat_forward.php?API=/api/stattranall/v1/' +
                    topicID +
                    '/list?action=' +
                    reAction
                    +
                    '&yymmBegin=' +
                    (yymm_b +'12') +
                    '&yymmEnd=' +
                    (yymm_b +'12' )+
                    '&statType=1&statSubType=999&subType=99&region='+
                    this.region+
                    '&cc=' +
                    Number(this.$route.query.ccNo) +
                    '&rcode=' +
                    Number(this.rcode) +
                    '&tt=' +
                    Number(this.tt) +
                    '&mm=' +
                    Number(this.mm)
                )
                // &region=1&cc='+this.cc+'&rcode='+this.rcode+'&tt='+this.tt+'&mm='+this.mm)
                .then(response => {
                this.dialog = false
                this.info = response.data
                var a = response.data
                for (var i = 0, n = a.length; i < n; i++) {
                  this.info2[0].femaleResult +=   a[i].lssumtotFemale;
                  this.info2[0].maleResult  +=   a[i].lssumtotMale;
                  this.info2[0].totalResult   +=  a[i].lssumtotTot;
                } 
                this.info.unshift({
                  lsrcodeDesc: 'ยอดรวมทั้งหมด',
                  lssumtotFemale: this.info2[0].femaleResult,
                  lssumtotMale: this.info2[0].maleResult,
                  lssumtotTot: this.info2[0].totalResult
                })
                })
                .catch(e => {
                this.dialog = false
                this.dialog2 = true
                this.errors.push(e)
                })
        }else if(topicID == 'statmoveout'){
        let a = this.action.toString();
        let reAction = '193';
            axios
                .get(
                  '../connectSAPI/stat_forward.php?API=/api/stattranall/v1/' +
                    topicID +
                    '/list?action=' +
                    reAction
                    +
                    '&yymmBegin=' +
                    (yymm_b +'12') +
                    '&yymmEnd=' +
                    (yymm_b +'12' )+
                    '&statType=1&statSubType=999&subType=99&region='+
                    this.region+
                    '&cc=' +
                    Number(this.$route.query.ccNo) +
                    '&rcode=' +
                    Number(this.rcode) +
                    '&tt=' +
                    Number(this.tt) +
                    '&mm=' +
                    Number(this.mm)
                )
                // &region=1&cc='+this.cc+'&rcode='+this.rcode+'&tt='+this.tt+'&mm='+this.mm)
                .then(response => {
                this.dialog = false
                this.info = response.data
                var a = response.data
                  for (var i = 0, n = a.length; i < n; i++) {
                    this.info2[0].femaleResult +=   a[i].lssumtotFemale;
                    this.info2[0].maleResult  +=   a[i].lssumtotMale;
                    this.info2[0].totalResult   +=  a[i].lssumtotTot;
                  }
                  this.info.unshift({
                    lsrcodeDesc: 'ยอดรวมทั้งหมด',
                    lssumtotFemale: this.info2[0].femaleResult,
                    lssumtotMale: this.info2[0].maleResult,
                    lssumtotTot: this.info2[0].totalResult
                  })
                })
                .catch(e => {
                this.dialog = false
                this.dialog2 = true
                this.errors.push(e)
                })
        }
    this.exportExcel()
  },
  methods: {                            
    onSelected (index) {
      if(index  == 0){
        this.selected = []
        return
      }
      if (this.selected.length >= 2) {
        this.selected.shift()
      }
      var lsAA
      if(this.selected[0].lsaa.toString().length == 1){
        lsAA = '0'+this.selected[0].lsaa.toString()
      }else{
        lsAA = this.selected[0].lsaa.toString()
      }
        let a = this.$router.resolve({ path: `/TableTemplate4/Area/${this.$route.query.topic}`,query:{ yymm:this.$route.query.yymm ,ccDesc:this.$route.query.ccDesc,topic:this.$route.query.topic,ccNo:this.$route.query.ccNo,rcodeNo:this.selected[0].lsrcode,rcodeDesc: this.selected[0].lsrcodeDesc} });
    var w = 1000;
      var h = 600;
    const dualScreenLeft = window.screenLeft !==  undefined ? window.screenLeft : window.screenX;
    const dualScreenTop = window.screenTop !==  undefined   ? window.screenTop  : window.screenY;

    const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    const systemZoom = width / window.screen.availWidth;
    const left = (width - w) / 2 / systemZoom + dualScreenLeft
    const top = (height - h) / 2 / systemZoom + dualScreenTop
      window.open(a.href, '_blank' , 
      `
      scrollbars=yes,
      resizable=yes,
      width=${window.innerWidth}, 
      height=${window.innerHeight}, 
      top=${dualScreenTop}, 
      left=${dualScreenLeft}
      `);
      this.selected = []
    },
    decimalMask(a){
      return a.toLocaleString()
    },
    Winclosed(){
    window.close()
    },
    back(){
      // window.location("http://iservices-ng.bora.dopa.go.th:8080/menu/statmonth/#/")
      
      if(this.id == 'statpop'){
        let a = 'ประชากรจากทะเบียนบ้าน'
        let b = {name: 'FilterPage', params: {id: this.id, title: a,binfofil: this.infoFilter,bmmyyb:this.yymm_b,bmmyye:this.yymm_e}}
        this.$router.push(b)
        // router.push({ path: `/${a}/${}` })
      }else if(this.id == 'stathouse'){
        let a = 'บ้านจากทะเบียนบ้าน'
        let b = {name: 'FilterPage', params: {id: this.id, title: a,binfofil: this.infoFilter,bmmyyb:this.yymm_b,bmmyye:this.yymm_e}}
        this.$router.push(b)
        
      }else if(this.id == 'statbirth'){
        let a = 'การเกิดจากสูติบัตร'
        let b = {name: 'FilterPage', params: {id: this.id, title: a,binfofil: this.infoFilter,bmmyyb:this.yymm_b,bmmyye:this.yymm_e}}
        this.$router.push(b)
        
      }else if(this.id == 'statmoveout'){
        let a = 'การย้ายออกจากใบแจ้งย้ายออก'
        let b = {name: 'FilterPage', params: {id: this.id, title: a,binfofil: this.infoFilter,bmmyyb:this.yymm_b,bmmyye:this.yymm_e}}
        this.$router.push(b)
        
      }else if(this.id == 'statmovein'){
        let a = 'การย้ายเข้าจากใบแจ้งย้ายเข้า'
        let b = {name: 'FilterPage', params: {id: this.id, title: a,binfofil: this.infoFilter,bmmyyb:this.yymm_b,bmmyye:this.yymm_e}}
        this.$router.push(b)
        
      }
    },
    
    showAlert (item) {
      this.$swal(item)
    },
    checkMonth(){
       if(this.yymm_e != undefined){
         let a =  this.MMandYY(this.yymm_b)
         let b =  this.MMandYY(this.yymm_e)
         return 'ตรวจสอบข้อมูลเดือน' + a + ' ถึง ' +b 
       }else{
         return 'ตรวจสอบข้อมูลเดือน'+this.MMandYY(this.yymm_b)
       }
    },
    MMandYY (x) {
      var getnumber = x
      var cast = getnumber.toString().split('')
      var year = cast[0] + cast[1]
      var month = cast[2] + cast[3]
      if (month == '01') {
        return 'มกราคม' + ' ' + '25' + year
      } else if (month == '02') {
        return 'กุมภาพันธ์' + ' ' + '25' + year
      } else if (month == '03') {
        return 'มีนาคม' + ' ' + '25' + year
      } else if (month == '04') {
        return 'เมษายน' + ' ' + '25' + year
      } else if (month == '05') {
        return 'พฤษภาคม' + ' ' + '25' + year
      } else if (month == '06') {
        return 'มิถุนายน' + ' ' + '25' + year
      } else if (month == '07') {
        return 'กรกฎาคม' + ' ' + '25' + year
      } else if (month == '08') {
        return 'สิงหาคม' + ' ' + '25' + year
      } else if (month == '09') {
        return 'กันยายน' + ' ' + '25' + year
      } else if (month == '10') {
        return 'ตุลาคม' + ' ' + '25' + year
      } else if (month == '11') {
        return 'พฤศจิกายน' + ' ' + '25' + year
      } else if (month == '12') {
        return 'ธันวาคม' + ' ' + '25' + year
      }
    },
    showTitle () {
      let a = this.flagtitle
      if (a == '11') {
        return 'ตรวจสอบข้อมูลแยกรายเดือน'
      } else {
        return 'ตรวจสอบข้อมูลแยกรายพื้นที่'
      }
    },
  //  showDetial () {
  //    if(this.action == 11 ) {
  //      return 'ทั่วประเทศ'
  //    }else if(this.action == 12){
  //     return 'ศูนย์ภาค ' + this.region
  //    }else if(this.action == 13){ 
  //       this.getCCCC()
  //       return 'จังหวัด: '+ this.getCCtext
  //    }else if(this.action == 14){ 
  //       this.getCCCC()
  //       this.getRRcode()
  //       return 'จังหวัด: '+ this.getCCtext + '  สำนักทะเบียน: ' +  this.getRRcodetext
  //    }else if(this.action == 15){ 
  //       this.getCCCC()
  //       this.getRRcode()
  //       this.getTTTT() 
  //       return 'จังหวัด: '+ this.getCCtext + '  สำนักทะเบียน: ' +  this.getRRcodetext + '  ตำบล: ' +  this.getTTText
  //    }else if(this.action == 16){ 
  //       this.getCCCC()
  //       this.getRRcode()
  //       // this.getTTTT() 
  //       this.getMMMM()
  //       this.getTTfromMM() 
  //       return 'จังหวัด: '+ this.getCCtext + '  สำนักทะเบียน: ' +  this.getRRcodetext  + '  ตำบล: ' +  this.getTTText + '  หมู่บ้าน: ' + this.getMMText
  //    } 
  showDetial () {
     if(this.cc == 10){
   
       return 'ทั่วประเทศ'
      if(this.action == 12){
      return 'ศูนย์ภาค ' + this.region
     }else if(this.action == 13){ 
        this.getCCCC()
        return 'จังหวัด: '+ this.getCCtext
     }else if(this.action == 14){ 
        this.getCCCC()
        this.getRRcode()
        return  'สำนักทะเบียน: ' +  this.getRRcodetext + '  จังหวัด: '+ this.getCCtext 
     }else if(this.action == 15){ 
        this.getCCCC()
        this.getRRcode()
        this.getTTTT() 
        return  'ตำบล: ' +  this.getTTText +  '  สำนักทะเบียน: ' +  this.getRRcodetext + '  จังหวัด: '+ this.getCCtext 
     }else if(this.action == 16){ 
        this.getCCCC()
        this.getRRcode()
        // this.getTTTT() 
        this.getMMMM()
        this.getTTfromMM() 
        var mmcutting = this.mm.substring(this.mm.length-2,this.mm.length+1)
        if(mmcutting.substring(0,1) == 0) {
          return  'หมู่: ' + mmcutting.substring(1)+ " "   + this.getMMText + '  ตำบล: ' +  this.getTTText +  '  สำนักทะเบียน: ' +  this.getRRcodetext + '  จังหวัด: '+ this.getCCtext 
        }else{
          return 'หมู่: ' + this.mm.substring(this.mm.length-2,this.mm.length+1)+' '  + this.getMMText + '  ตำบล: ' +  this.getTTText +  '  สำนักทะเบียน: ' +  this.getRRcodetext + '  จังหวัด: '+ this.getCCtext 
        }
     } 
    }else{
      // if(this.action == 11 ) {
       return 'ทั่วประเทศ'
    if(this.action == 12){
      return 'ศูนย์ภาค ' + this.region
     }else if(this.action == 13){ 
        this.getCCCC()
        return 'จังหวัด: '+ this.getCCtext
     }else if(this.action == 14){ 
        this.getCCCC()
        this.getRRcode()
        return  'อำเภอ: ' +  this.getRRcodetext + '  จังหวัด: '+ this.getCCtext 
     }else if(this.action == 15){ 
        this.getCCCC()
        this.getRRcode()
        this.getTTTT() 
        return  'ตำบล: ' +  this.getTTText +  '  อำเภอ: ' +  this.getRRcodetext + '  จังหวัด: '+ this.getCCtext 
     }else if(this.action == 16){ 
        this.getCCCC()
        this.getRRcode()
        // this.getTTTT() 
        this.getMMMM()
        this.getTTfromMM() 
       var mmcutting = this.mm.substring(this.mm.length-2,this.mm.length+1)
        if(mmcutting.substring(0,1) == 0) {
          return  'หมู่: ' + mmcutting.substring(1) + " "  + this.getMMText + '  ตำบล: ' +  this.getTTText +  '  อำเภอ: ' +  this.getRRcodetext + '  จังหวัด: '+ this.getCCtext 
        }else{
          return 'หมู่: ' + this.mm.substring(this.mm.length-2,this.mm.length+1)+' '  + this.getMMText + '  ตำบล: ' +  this.getTTText +  '  อำเภอ: ' +  this.getRRcodetext + '  จังหวัด: '+ this.getCCtext 
        }
     } 
    }
    },
    getCCCC() { 
     let response =  axios.get('../connectSAPI/stat_forward.php?API=/api/tabdb/catm/v1/?code_like=' + this.cc + '%&terminateDate=0')
          .then((response) => {
            this.getCCtext =  response.data[0].description.thai
            
          })
          .catch(function (error) {
            console.log(error)
        })
    },
    getRRcode() { 
     let response =  axios.get('../connectSAPI/stat_forward.php?API=/api/tabdb/catm/v1/?code_like=' + this.rcode + '%&terminateDate=0')
          .then((response) => {
            this.getRRcodetext =  response.data[0].description.thai
            
          })
          .catch(function (error) {
            console.log(error)
        })
    },
    getTTTT() { 
     let response =  axios.get('../connectSAPI/stat_forward.php?API=/api/tabdb/catm/v1/?code_like=' + this.tt + '%&terminateDate=0')
          .then((response) => {
            this.getTTText =  response.data[0].description.thai
            
          })
          .catch(function (error) {
            console.log(error)
        })
    },
     getMMMM() { 
     let response =  axios.get('../connectSAPI/stat_forward.php?API=/api/tabdb/catm/v1/?code_like=' + this.mm + '%&terminateDate=0')
          .then((response) => {
           this.getMMText =  response.data[0].description.thai
            
          })
          .catch(function (error) {
            console.log(error)
        })
    },
     getTTfromMM() { 
        let T = this.mm.substring(0,6)
        let response =  axios.get('../connectSAPI/stat_forward.php?API=/api/tabdb/catm/v1/?code_like=' + T + '%&terminateDate=0')
          .then((response) => {
           this.getTTText =  response.data[0].description.thai
            
          })
          .catch(function (error) {
            console.log(error)
        })
    },
    exportExcel() {
      let exName = "";
      let exTitle = "";
      switch (this.$route.query.topic) {
        case "statpop":
          exName = "สถิติจำนวนประชากรและบ้าน_พื้นที่";
          exTitle = "สถิติจำนวนประชากรและบ้าน";
          this.excelField = {
            "พื้นที่": "lsrcodeDesc",
            "ชาย (คน)": "lssumtotMale",
            "หญิง (คน)": "lssumtotFemale",
            "รวม (คน)": "lssumtotPop",
            "บ้าน (หลัง)": "lssumtotHouse",
          };

          break;
        case "statbirth":
          exName = "สถิติจำนวนการเกิด_พื้นที่";
          exTitle = "สถิติจำนวนการเกิด";
          this.excelField = {
            "พื้นที่": "lsrcodeDesc",
            "ชาย (คน)": "lssumtotalBoy",
            "หญิง (คน)": "lssumtotalGirl",
            "รวม (คน)": "lssumtotalAll",
          };
          break;
        case "statdeath":
          exName = "สถิติจำนวนการตาย_พื้นที่";
          exTitle = "สถิติจำนวนการตาย";
          break;
        case "statmovein":
          exName = "สถิติจำนวนการย้ายเข้า_พื้นที่";
          exTitle = "สถิติจำนวนการย้ายเข้า";
          break;
        case "statmoveout":
          exName = "สถิติจำนวนการย้ายออก_พื้นที่";
          exTitle = "สถิติจำนวนการย้ายออก";
          break;

        default:
          break;
      }
      this.excelName = exName + this.$route.query.ccDesc;
      this.excelTitle = [
        exTitle,
        `พื้นที่ ${this.$route.query.ccDesc}`,
        `ข้อมูล ปี 25${this.$route.query.yymm}`,
      ];
      if (["statdeath", "statmovein", "statmoveout"].includes(this.$route.query.topic)) {
        this.excelField = {
          "พื้นที่": "lsrcodeDesc",
          "ชาย (คน)": "lssumtotMale",
          "หญิง (คน)": "lssumtotFemale",
          "รวม (คน)": "lssumtotTot",
        };
      }
    },
    pushData() {
      let pushdata = null;
      switch (this.$route.query.topic) {
        case "statpop":
          for (let i = 0; i < this.info.length; i++) {
            this.info[i].lssumtotMale = this.decimalMask(this.info[i].lssumtotMale)
            this.info[i].lssumtotFemale = this.decimalMask(this.info[i].lssumtotFemale)
            this.info[i].lssumtotPop = this.decimalMask(this.info[i].lssumtotPop)
            this.info[i].lssumtotHouse = this.decimalMask(this.info[i].lssumtotHouse)
          }
          pushdata = {
            lsrcodeDesc: "<b>ยอดรวมทั้งหมด<b>",
            lssumtotMale: `<b>${this.decimalMask(this.info2[0].maleResult)}<b>`,
            lssumtotFemale: `<b>${this.decimalMask(this.info2[0].femaleResult )}<b>`,
            lssumtotPop: `<b>${this.decimalMask(this.info2[0].totalResult)}<b>`,
            lssumtotHouse: `<b>${this.decimalMask(this.info2[0].houseResult)}<b>`,
          };
          break;
        case "statbirth":
          for (let i = 0; i < this.info.length; i++) {
            this.info[i].lssumtotalBoy = this.decimalMask(this.info[i].lssumtotalBoy)
            this.info[i].lssumtotalGirl = this.decimalMask(this.info[i].lssumtotalGirl)
            this.info[i].lssumtotalAll = this.decimalMask(this.info[i].lssumtotalAll)
          }
          pushdata = {
            lsrcodeDesc: "<b>ยอดรวมทั้งหมด<b>",
            lssumtotalBoy: `<b>${this.decimalMask(this.info2[0].boyResult)}<b>`,
            lssumtotalGirl: `<b>${this.decimalMask(this.info2[0].girlResult)}<b>`,
            lssumtotalAll: `<b>${this.decimalMask(this.info2[0].allResult)}<b>`,
          };
          break;
        case "statdeath": case "statmovein" :case "statmoveout":
          for (let i = 0; i < this.info.length; i++) {
            this.info[i].lssumtotMale = this.decimalMask(this.info[i].lssumtotMale)
            this.info[i].lssumtotFemale = this.decimalMask(this.info[i].lssumtotFemale)
            this.info[i].lssumtotTot = this.decimalMask(this.info[i].lssumtotTot)
          }
          pushdata = {
            lsrcodeDesc: "<b>ยอดรวมทั้งหมด<b>",
            lssumtotMale: `<b>${this.decimalMask(this.info2[0].maleResult)}<b>`,
            lssumtotFemale: `<b>${this.decimalMask(this.info2[0].femaleResult)}<b>`,
            lssumtotTot: `<b>${this.decimalMask(this.info2[0].totalResult)}<b>`,
          };
          break;

        default:
          break;
      }

      this.info.push(pushdata);
      this.info.shift()
    },
    popData() {
      switch (this.$route.query.topic) {
        case "statpop":
          this.info.pop();
          this.info.unshift({
            lsrcodeDesc: "ยอดรวมทั้งหมด",
            lssumtotMale: this.decimalMask(this.info2[0].maleResult),
            lssumtotFemale: this.decimalMask(this.info2[0].femaleResult ),
            lssumtotPop: this.decimalMask(this.info2[0].totalResult),
            lssumtotHouse: this.decimalMask(this.info2[0].houseResult),
          })
          break;
        case "statbirth":
          this.info.pop();
          this.info.unshift({
            lsrcodeDesc: "ยอดรวมทั้งหมด",
            lssumtotalBoy: this.decimalMask(this.info2[0].boyResult),
            lssumtotalGirl: this.decimalMask(this.info2[0].girlResult),
            lssumtotalAll: this.decimalMask(this.info2[0].allResult),
          })
          break;
        case "statdeath": case "statmovein" :case "statmoveout":
          this.info.pop();
          this.info.unshift({
            lsrcodeDesc: "ยอดรวมทั้งหมด",
            lssumtotMale: this.decimalMask(this.info2[0].maleResult),
            lssumtotFemale: this.decimalMask(this.info2[0].femaleResult),
            lssumtotTot: this.decimalMask(this.info2[0].totalResult),
          })
          break;

        default:
          break;
      }
    },
    skipScan(){
      this.divExcel = true
    }
  }
}


// document.documentElement.style.overflow = 'hidden';  // firefox, chrome
// document.body.scroll = "no"; // ie only
</script>

<style>
.theme--light .v-datatable thead th.column,
.theme--light .v-datatable thead th.column.sortable.active,
.theme--light .v-datatable thead th.column.sortable:hover,
.theme--light .v-datatable thead th.column.sortable.active i {
  color: white;
  background-color: #0BACF2;
  font-size: 16px;
  /* padding-left:8em; */
}
.excelbtn {
  color: white;
  background-color: darkgreen;
  height: 28px;
  width: 154px;
  padding-top: 2px;
  cursor: pointer;
}
.h1 {
  color:black; 
  font-size:25px;
}
.h3 {
  color:black; 
  font-size:20px;
}
.colorIMG2 {
  color: #ff0000;
}
table.v-table tbody td {
  font-weight: bold;
  font-size: 16px;
}
@media (max-width: 768px) {
  .h3 {
    color:black; 
    font-size: 16px;
  }
  .h1 {
    color:black; 
    font-size: 20px;
  }
  table.v-table tbody td {
    font-weight: bold;
    font-size: 12px;
  }
}
</style>
